import React from 'react'
import PropTypes from 'prop-types'

const InputSingleDataTag = props => (
  <div className="add-input-container">
    <input
      className="input-tag"
      onChange={props.onChange}
      value={props.value}
    />
    <button
      className="btn-cancel"
      onClick={props.onClickCancel}
    >
      Cancel
    </button>
    <button
      className={`btn-confirm ${props.value ? '' : 'btn-disabled'}`}
      onClick={props.onClickConfirm}
      disabled={props.value === ''}
    >
      Confirm
    </button>
  </div>
)

InputSingleDataTag.defaultProps = {
  onChange: () => {},
  onClickCancel: () => {},
  onClickConfirm: () => {},
  value: '',
}

InputSingleDataTag.propTypes = {
  onChange: PropTypes.func,
  onClickCancel: PropTypes.func,
  onClickConfirm: PropTypes.func,
  value: PropTypes.string,
}

export default InputSingleDataTag
